"use strict";
(function (global) {

  /**
   * Смена пароля пользователя.
   *
   * @function WebAccess.services.authenticaion.changePassword
   */
  global.authenticaion.changePassword = function (userName, oldPassword, newPassword, confirmPassword, isFirstLogin, success, failed) {
    CallService("/Authentication.asmx/ChangePassword", {
      Login: userName,
      PasswordOld: oldPassword,
      PasswordNew: newPassword,
      PasswordConfirm: confirmPassword,
      IsFirstLogin: isFirstLogin
    }, function (res) {
      if (res.Success) {
        if (success)
          success(res);
      } else {
        if (failed)
          failed(res);
      }
    });
    return false;
  };

  /**
  * Вход пользователя.
  *
  * @function WebAccess.services.authenticaion.loginUser
  */
  global.authenticaion.loginUser = function (providerName, userName, userRealm, userPassword, rememberMe, success, failed) {
    var request = {
      UserName: userName,
      Password: userPassword,
      Realm: userRealm,
      ProviderName: providerName,
      RememberMe: rememberMe
    };
    
    CallService("/Authentication.asmx/Login", request, function (res) {
      if (res.Success) {
        if (success)
          success(res);
      } else {
        if (failed)
          failed(res);
      }
    });
    return false;
  };

})(window.WebAccess.services);